import { topics, latestFeed } from '@/mocks/news';

export default function TopicSection() {
  return (
    <section
      id="topics"
      className="scroll-mt-16 border-y border-background-200 bg-background-100/60"
    >
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold tracking-widest text-accent-700">
              <span className="h-px w-8 bg-accent-500" /> 吃瓜话题 · 专题连载
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              一个话题，挖到底
            </h2>
          </div>
          <span className="hidden items-center gap-2 whitespace-nowrap text-sm text-foreground-600 sm:flex">
            <i className="ri-refresh-line text-primary-600" aria-hidden="true" /> 连载持续更新中
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 专题大卡 */}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2">
            {topics.map((t) => (
              <a
                key={t.id}
                href="#deep"
                className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg border border-background-200"
              >
                <img
                  src={t.image}
                  alt={t.title}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
                <div className="relative z-10 p-6">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                      {t.tag}
                    </span>
                    <span className="whitespace-nowrap rounded-md bg-background-50/20 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                      {t.read}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-black leading-snug text-background-50 md:text-xl">
                    {t.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-100/80">
                    {t.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between text-xs text-background-100/70">
                    <span>{t.time}</span>
                    <span className="flex items-center gap-1 font-semibold text-accent-400">
                      进入专题 <i className="ri-arrow-right-line" aria-hidden="true" />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* 最新快讯时间轴 */}
          <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-base font-bold text-foreground-950">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-broadcast-line text-sm" aria-hidden="true" />
              </span>
              最新快讯
            </h3>
            <ul className="mt-2">
              {latestFeed.map((f, i) => (
                <li key={f.text} className="flex gap-3 py-3">
                  <div className="flex flex-col items-center">
                    <span className="mt-1.5 h-2 w-2 rounded-full bg-accent-500" />
                    {i !== latestFeed.length - 1 && (
                      <span className="mt-1 w-px flex-1 bg-background-200" />
                    )}
                  </div>
                  <div>
                    <p className="line-clamp-2 text-sm leading-relaxed text-foreground-800">{f.text}</p>
                    <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 font-semibold text-secondary-800">
                        {f.tag}
                      </span>
                      {f.time}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}